module.exports = __webpack_public_path__ + "img/logomenu.2c8f45b4.png";